module.exports = __webpack_public_path__ + "c7298baa54dae3bf9dd510c0982d5ce8.pdf";